import { getLinkTg } from "./getLinkRef";

export const getLink = (val) => {
  const splitVal = val.split("?");
  return splitVal.length > 1
    ? splitVal[0] + getLinkTg() + splitVal[1]
    : splitVal + getLinkTg();
};
